/* eslint-disable prettier/prettier */
import axios from 'axios'

export const countriesAPIAction = () => async (dispatch) => {
  const countries = await axios.get('https://mocki.io/v1/69ee6c78-3f78-4219-9f88-ae406509bdf1')
  dispatch({
    type: 'COUNTRY_FETCHING',
    payload: countries.data,
  })
}
export const statesAPIAction = () => async (dispatch) => {
  const states = await axios.get('https://mocki.io/v1/7736f268-5b67-4d39-9d86-cec2b3dfc507')
  dispatch({
    type: 'STATES_FETCHING',
    payload: states.data,
  })
}
